// import Swiper JS
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

// import Swiper styles
import 'swiper/swiper-bundle.css';

Swiper.use([Autoplay, Navigation, Pagination]);


var mySwiper = new Swiper('.swiper-container', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  simulateTouch: false,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
})
